var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObituaries(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 189,
    viewBox: "0 0 189 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.3505 40.0315C116.509 40.0315 134.49 58.0255 134.49 80.1709V126.618C134.49 130.904 131.012 134.382 126.726 134.382H61.9613C57.6751 134.382 54.1976 130.904 54.1976 126.618V80.1709C54.1976 58.012 72.1916 40.0315 94.337 40.0315H94.3505Z",
    fill: "white",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2238 86.6542H118.477",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2238 100.618H118.477",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2238 114.582H118.477",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.514 132.212H53.1869C48.6386 132.212 44.9514 135.899 44.9514 140.447C44.9514 144.996 48.6386 148.683 53.1869 148.683H135.514C140.063 148.683 143.75 144.996 143.75 140.447C143.75 135.899 140.063 132.212 135.514 132.212Z",
    fill: "white",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3505 56.3947V71.0998",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.0681 63.754H89.6331",
    stroke: "#415574",
    strokeWidth: 6.73932,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObituaries);
export default __webpack_public_path__ + "static/media/obituaries.857f3f8205f83ae65ab81cfea0687a28.svg";
export { ForwardRef as ReactComponent };